import { h } from 'preact';

const CalendarEmpty = (props) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" role='img' {...props}>
			<path d="M12.717 12l1.035-1.034a.51.51 0 0 0 0-.718.51.51 0 0 0-.718 0L12 11.283l-1.034-1.035a.51.51 0 0 0-.718 0 .51.51 0 0 0 0 .718L11.283 12l-1.035 1.034a.511.511 0 0 0 .007.724c.088.084.198.119.353.143l.241-.031L12 12.717l1.034 1.035a.514.514 0 0 0 .358.148l.242-.031.117-.117a.51.51 0 0 0 0-.718L12.717 12z"/>
			<path d="M8.555 14H3c-.551 0-1-.449-1-1V7h12v1.555c.378.22.714.497 1 .825V4a2 2 0 0 0-2-2h-1v-.5a.5.5 0 0 0-1 0V2H5v-.5a.5.5 0 0 0-1 0V2H3a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h6.38a3.976 3.976 0 0 1-.825-1zM2 4c0-.551.449-1 1-1h1v.5a.5.5 0 0 0 1 0V3h6v.5a.5.5 0 0 0 1 0V3h1c.551 0 1 .449 1 1v2H2V4z" opacity=".3" fill-rule="evenodd" clip-rule="evenodd"/>
		</svg>
	);
};

export default CalendarEmpty;
